
import minutesToHoursString from '@/helpers/minutesToHoursString'

export default {
  data() {
    return {
      showMaxAirlines: 5,
      isOpen: false,
      submitted: false,
      selectedStops: [0, 1, 2],
      selectedOutboundDuration: Infinity,
      selectedInboundDuration: Infinity,
      isAirlinesCollapsed: true,
      limitAirlineCount: 300,
      limitAirlineCountMin: 270
    }
  },
  computed: {
    searchAirlines () {
      return this.$store.state.searchAirlines
    },
    searchAirlinesMain () {
      return this.searchAirlines.filter(item => item.code !== '00')
    },
    searchAirlinesMultiple () {
      return this.searchAirlines.filter(item => item.code === '00')
    },
    searchAirlinesGroups () {
      return [this.searchAirlinesMain, this.searchAirlinesMultiple]
    },
    parsedFilteredResults () {
      return this.$store.getters.parsedFilteredResults
    },
    results () {
      const results = this.$store.state.searchResults
      if (!results.length) return []
      return results
    },
    filters () {
      const OutboundDurations = this.results.map(flight => flight.legs[0]?.duration)
      const InboundDurations = this.results.map(flight => flight.legs[1]?.duration)

      const minOutboundDuration = Math.min(...OutboundDurations)
      const maxOutboundDuration = Math.max(...OutboundDurations)
      const minInboundDuration = Math.min(...InboundDurations)
      const maxInboundDuration = Math.max(...InboundDurations)

      const stops = this.results.map((flight) => flight.stops)
      const stopOptions = Array.from(new Set(stops))

      return {
        minOutboundDuration,
        maxOutboundDuration,
        minInboundDuration,
        maxInboundDuration,
        stopOptions
      }
    },
    isRoundtrip () {
      // return this.results[0].legs.length === 2
      return this.results.every(flight => flight.legs && flight.legs.length > 1)
    },
    rejectedAirlineCodes () {
      const r = this.$store.state.searchFilters.rejectedAirlines
      return Array.isArray(r) ? r : []
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: 'handleWatchFilters'
    },
    '$store.state.searchFilters': {
      deep: true,
      handler (newVal) {
        const filtersCleared =
          newVal.stops === null &&
          newVal.outboundDuration === null &&
          newVal.inboundDuration === null &&
          (!newVal.rejectedAirlines || newVal.rejectedAirlines.length === 0)

        if (filtersCleared) {
          this.submitted = false
          this.selectedStops = [0, 1, 2]
        }
      }
    }
  },
  methods: {
    minutesToHoursString,
    displayAirlineCount (count) {
      return count > this.limitAirlineCount
        ? this.limitAirlineCountMin + Math.floor(Math.random() * (this.limitAirlineCount - this.limitAirlineCountMin + 1))
        : count
    },
    scrollTo (id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
    handleStopChange() {
      this.submitted = true
      this.$store.commit('setSearchFilters', {
        stops: this.selectedStops
      });
    },
    handleOutboundDurationChange() {
      this.submitted = true
      this.$store.commit('setSearchFilters', {
        outboundDuration: this.selectedOutboundDuration
      });
    },
    handleInboundDurationChange() {
      this.submitted = true
      this.$store.commit('setSearchFilters', {
        inboundDuration: this.selectedInboundDuration
      });
    },
    handleWatchFilters () {
      const searchFilters = this.$store.state.searchFilters

      this.selectedOutboundDuration = searchFilters.outboundDuration !== null ? searchFilters.outboundDuration : this.filters.maxOutboundDuration
      this.selectedInboundDuration = searchFilters.inboundDuration !== null ? searchFilters.inboundDuration : this.filters.maxInboundDuration
    },
    clearFilters () {
      this.submitted = false
      this.$store.commit('clearSearchFilters')
      this.selectedStops = [0, 1, 2]
      this.selectedOutboundDuration = this.filters.maxOutboundDuration
      this.selectedInboundDuration = this.filters.maxInboundDuration
    },
    isAirlineChecked (code) {
      return !this.rejectedAirlineCodes.includes(code)
    },
    toggleAirline (e) {
      const code = e.target.value
      const next = [...this.rejectedAirlineCodes]
      if (e.target.checked) {
        const index = next.indexOf(code)
        if (index !== -1) next.splice(index, 1)
      } else if (!next.includes(code)) {
        next.push(code)
      }
      this.submitted = true
      this.$store.commit('setSearchFilters', {
        rejectedAirlines: next.length ? next : null
      })
    }
  }
}
